import { openDB } from 'idb';

const DB_NAME = 'aml-prototype-db';
const DB_VERSION = 10; // <-- IMPORTANT: Final Version is 8

const initDB = async () => {
  const db = await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      const stores = db.objectStoreNames;
      if (stores.contains('cases')) db.deleteObjectStore('cases');
      if (stores.contains('users')) db.deleteObjectStore('users');
      if (stores.contains('rules')) db.deleteObjectStore('rules');
      if (stores.contains('customers')) db.deleteObjectStore('customers');
      if (stores.contains('alerts')) db.deleteObjectStore('alerts');
      if (stores.contains('permissions')) db.deleteObjectStore('permissions');
      if (stores.contains('ml_models')) db.deleteObjectStore('ml_models');
      if (stores.contains('mappings')) db.deleteObjectStore('mappings'); // New
      if (stores.contains('risk_models')) db.deleteObjectStore('risk_models'); // New
      if (stores.contains('watchlists')) db.deleteObjectStore('watchlists'); // New

      db.createObjectStore('cases', { keyPath: 'id', autoIncrement: true }).createIndex('status', 'status');
      db.createObjectStore('users', { keyPath: 'id', autoIncrement: true }).createIndex('team', 'team');
      db.createObjectStore('rules', { keyPath: 'id', autoIncrement: true }).createIndex('environment', 'environment');
      db.createObjectStore('customers', { keyPath: 'id' }).createIndex('riskRating', 'riskRating');
      db.createObjectStore('alerts', { keyPath: 'id', autoIncrement: true }).createIndex('status', 'status');
      db.createObjectStore('transactions', { keyPath: 'id', autoIncrement: true });
      db.createObjectStore('auditLog', { keyPath: 'id', autoIncrement: true });
      db.createObjectStore('masters', { keyPath: 'id' });
      db.createObjectStore('permissions', { keyPath: 'role' });
      db.createObjectStore('ml_models', { keyPath: 'id' });
      db.createObjectStore('mappings', { keyPath: 'id' }); // NEW STORE
      db.createObjectStore('risk_models', { keyPath: 'id' }); // NEW STORE
      db.createObjectStore('watchlists', { keyPath: 'id' }); // NEW STORE

    },
  });
  return db;
};

// ... (The rest of the dbService code is identical to the previous version)
const dbPromise = initDB();

const dbService = {
  getAll: async (storeName) => {
    const db = await dbPromise;
    return db.getAll(storeName);
  },
  getById: async (storeName, id) => {
    const db = await dbPromise;
    return db.get(storeName, id);
  },
  add: async (storeName, item) => {
    const db = await dbPromise;
    return db.add(storeName, item);
  },
  update: async (storeName, item) => {
    const db = await dbPromise;
    return db.put(storeName, item);
  },
  delete: async (storeName, id) => {
    const db = await dbPromise;
    return db.delete(storeName, id);
  },
  addLog: async (logEntry) => {
    const db = await dbPromise;
    const log = {
      timestamp: new Date().toISOString(),
      user: logEntry.user,
      action: logEntry.action,
      details: logEntry.details || '',
    };
    return db.add('auditLog', log);
  },
};

export default dbService;